module.exports = __webpack_public_path__ + "static/media/dealtOnlyQueensJacks_1.96fa3a66.svg";